import {Component, inject} from '@angular/core';
import {SignInComponent} from "../sign-in/sign-in.component";
import {ToastService} from "@components";
import {Router} from "@angular/router";

@Component({
  selector: 'wun-sign-in-page',
  imports: [
    SignInComponent
  ],
  templateUrl: './sign-in-page.component.html',
  styleUrl: './sign-in-page.component.scss'
})
export class SignInPageComponent {

  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  userSigned() {
    this.toastService.addMessage({
      severity: 'success',
      title: 'signup.registrationSuccess',
      id: Math.random().toString(36)
    })
    this.router.navigate(['/']);
  }
}
